import React, { Component } from 'react';
import { Link, withRouter, Prompt } from 'react-router-dom';
import { connect } from 'react-redux';
import { retrieve, update, reset } from 'actions/company-settings/update';
import { Form, Header, Grid, Message } from 'semantic-ui-react';
import { EssorButton, CompanyListEdit, toast } from 'components';
import { percentageFormat, inputFormat } from 'utils/formatter';
import Cleave from 'cleave.js/react';
import { withTranslation } from 'react-i18next';
import { isEmpty, last } from 'lodash';

class DayOffReasons extends Component {
  state = {
    value: {},
    label: '',
    rate: '',
    labelError: false,
    rateError: false,
    isSettingsLoaded: false,

    id: null,
    btnSave: false,

    hasDataChanged: false,
  };

  componentDidMount() {
    const { retrieve, selectedCompany } = this.props;

    retrieve(`/company_settings?company=${selectedCompany.id}&name=DAY_OFF_REASONS`);
  }

  componentDidUpdate() {
    const { reset, selectedCompany, retrieve, updated } = this.props;

    if (updated) {
      reset();
      retrieve(`/company_settings?company=${selectedCompany.id}&name=DAY_OFF_REASONS`);
    }
  }

  componentWillUnmount() {
    const { reset } = this.props;
    reset();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.retrieved && nextProps.retrieved['hydra:member'][0].name === 'DAY_OFF_REASONS' && !prevState.isSettingsLoaded) {
      return {
        isSettingsLoaded: true,
        value: nextProps.retrieved['hydra:member'][0].value,

        id: isEmpty(nextProps.retrieved['hydra:member'][0].value) ? 0 : last(nextProps.retrieved['hydra:member'][0].value).id,
      };
    }

    if (nextProps.updated) {
      return {
        createOfferModalOpen: false,
        label: '',
      };
    }

    if (prevState.hasDataChanged) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }

    return null;
  }

  handleInputChange = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  handleAddItem = () => {
    const {
      label,
      rate,
      value,
      id,
      rateCleave,
    } = this.state;

    this.setState({
      labelError: false,
      rateError: false,
    });

    let isValid = true;

    if (label.trim() === '') {
      isValid = false;

      this.setState({
        labelError: true,
      });
    }

    if (rate.trim() === '') {
      isValid = false;

      this.setState({
        rateError: true,
      });
    }

    if (!isValid) return;

    const data = {
      id: id + 1,
      label,
      rate: inputFormat(rate),
    };

    value.push(data);

    this.setState({
      value,
      label: '',
      rate: '',
      id: data.id,
      hasDataChanged: true,
    });

    rateCleave.setRawValue('');
  };

  cleanRate = (cleave) => {
    this.setState({
      rateCleave: cleave,
    });
  };

  handleDelete = (e) => {
    const { value } = this.state;
    const index = e.target.getAttribute('data-id');

    value.splice(index, 1);

    this.setState({
      value,
    });
  };

  handleOnSubmit = () => {
    const { value } = this.state;

    const { update, retrieved, history, t } = this.props;

    this.setState({
      labelError: false,
      rateError: false,
      btnSave: true,
      hasDataChanged: false,
    });

    const data = {
      value,
    };

    update(retrieved['hydra:member'][0], data)
      .then(() => {
        toast.success(t('dayOffReasonsUpdateSuccess'));
        history.push('/company/settings/day-off-reasons');
      });
  };

  onSubmitList = (item, hasDataChanged) => {
    this.setState({
      value: item,
      hasDataChanged,
    });
  };

  render() {
    const {
      label,
      rate,
      labelError,
      rateError,
      value,
      btnSave,
      hasDataChanged,
    } = this.state;

    const callbacks = {
      func: value => percentageFormat(value),
    };

    const { retrieveLoading, updateLoading, updateError, t } = this.props;

    return (
      <div className="section-container">
        <div className="section-general">
          <Prompt
            when={hasDataChanged}
            message={t('warningYouHaveUnsavedData')}
          />
          <div className="option-buttons-container clearfix">
            <Header as="h3">{t('companiesDayOffReasons')}</Header>
            <EssorButton as={Link} to="/company/settings/day-off-reasons" type="chevron left" size="tiny" floated="right">
              {t('buttonBack')}
            </EssorButton>
          </div>
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <Form className="margin-top-bot main-form" loading={retrieveLoading || updateLoading} size="small">
                  <Form.Group inline>
                    <Form.Input
                      label={t('formLabel')}
                      name="label"
                      placeholder={t('formPHLabel')}
                      value={label}
                      onChange={this.handleInputChange}
                      error={labelError}
                    />
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Input
                      label={t('formRate')}
                      error={rateError}
                    >
                      <Cleave
                        value={inputFormat(rate, true)}
                        name="rate"
                        onInit={this.cleanRate}
                        placeholder={t('formPHRate')}
                        onChange={this.handleInputChange}
                        autoComplete="off"
                        options={{
                          numeralDecimalMark: ',',
                          numeral: true,
                          numeralDecimalScale: 2,
                          numeralPositiveOnly: true,
                        }}
                      />
                    </Form.Input>
                  </Form.Group>

                  {updateError
                    && (
                      <Message negative>
                        <p>{updateError}</p>
                      </Message>
                    )
                  }
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <div className="clearfix">
            <EssorButton type="plus" onClick={this.handleAddItem} size="tiny" floated="right">
              {t('buttonSubmit')}
            </EssorButton>
          </div>
          {
            !isEmpty(value)
            && (
              <React.Fragment>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={14}>
                      <Form className="margin-top-bot main-form" loading={retrieveLoading || updateLoading} size="small">
                        <CompanyListEdit
                          dataValue={value}
                          onEditList={(valueEdit, changed) => this.onSubmitList(valueEdit, changed)}
                          btnSave={btnSave}
                          keyWord="rate"
                          align="format-number-fr"
                          format={callbacks}
                          loading={updateLoading}
                          inputsNumeric={[1]}
                        />
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>

                <div className="clearfix">
                  <EssorButton type="check" onClick={this.handleOnSubmit} size="tiny" floated="right">
                    {t('buttonSave')}
                  </EssorButton>
                </div>
              </React.Fragment>
            )
          }
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  retrieve: id => dispatch(retrieve(id)),
  update: (item, values) => dispatch(update(item, values)),
  reset: () => {
    dispatch(reset());
  },
});

const mapStateToProps = state => ({
  retrieveError: state.companySettings.update.retrieveError,
  retrieveLoading: state.companySettings.update.retrieveLoading,
  updateError: state.companySettings.update.updateError,
  updateLoading: state.companySettings.update.updateLoading,
  retrieved: state.companySettings.update.retrieved,
  updated: state.companySettings.update.updated,
  selectedCompany: state.userCompanies.select.selectedCompany,
});


const Main = connect(mapStateToProps, mapDispatchToProps)(DayOffReasons);

export default withTranslation()(withRouter(Main));
